import { Endpoint, HttpApi, s } from "@kosmod/pancake";
import { GameID } from "@kosmod/sesame";
import { AssetID, AssetMeta } from "./asset";

export const assetsAPI = HttpApi.Branch({
  '/': HttpApi.Methods({
    'GET': Endpoint.Raw({
      query: s.o({ game: GameID, asset: AssetID }),
      responseStream: true,
    }),
    'POST': Endpoint.Json({
      requestBody: s.o({
        game: GameID,
        contentLength: s.num,
        contentType: s.str
      }),
      responseBody: s.o({
        uploadURL: s.str,
        assetId: AssetID,
      })
    })
  }),
  
  '/meta': HttpApi.Methods({
    'GET': Endpoint.Json({
      query: s.o({ game: GameID, asset: s.optional(AssetID) }),
      responseBody: s.a(AssetMeta)
    }),
  }),

  '/upload': HttpApi.Methods({
    'PUT': Endpoint.Raw({
      query: s.o({ game: GameID, asset: AssetID }),
      requestStream: true
    })
  }),
})

export type AssetClient = HttpApi.Handler<"client", typeof assetsAPI>;
export type AssetURLMap = HttpApi.URLMap<typeof assetsAPI>;
export type AssetServerHandler = HttpApi.Handler<"server", typeof assetsAPI>;